import React from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { BUILDER } from "@/constants/testIds";

const KIND_META = {
  parent: {
    title: "Add a parent",
    verb: "Pick who to record as a parent of",
    new: "Add a new parent",
  },
  spouse: {
    title: "Add a spouse",
    verb: "Pick a spouse for",
    new: "Add a new spouse",
  },
  child: {
    title: "Add a child",
    verb: "Pick a child of",
    new: "Add a new child",
  },
};

export default function LinkPickerDialog({
  open, kind, anchor, candidates, onClose, onPickExisting, onPickNew,
}) {
  if (!kind) return null;
  const meta = KIND_META[kind] || KIND_META.child;

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        data-testid={BUILDER.linkPickerDialog}
        className="bg-ivory border-ivory-300 max-w-md p-0 overflow-hidden"
      >
        <div className="p-7">
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl tracking-tight text-ink">
              {meta.title}
            </DialogTitle>
            <DialogDescription className="text-ink-50 mt-1">
              {meta.verb} <span className="text-ink font-medium">{anchor?.name}</span>.
              You can pick someone already in this tree, or add a new person.
            </DialogDescription>
          </DialogHeader>

          <button
            onClick={onPickNew}
            className="mt-6 w-full h-12 rounded-full bg-saffron text-ivory text-sm font-medium hover:bg-saffron-deep transition"
          >
            + {meta.new}
          </button>

          {candidates.length > 0 && (
            <>
              <div className="mt-6 text-xs uppercase tracking-[0.2em] text-ink-50">
                Or link to someone already added
              </div>
              <ul className="mt-3 max-h-[280px] overflow-auto rounded-xl border border-ivory-300 divide-y divide-ivory-300 bg-white/60">
                {candidates.map((p) => (
                  <li key={p.id}>
                    <button
                      data-testid={BUILDER.linkPickerOption(p.id)}
                      onClick={() => onPickExisting(p.id)}
                      className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-ivory-100 transition"
                    >
                      <div className="w-9 h-9 rounded-full overflow-hidden border border-ivory-300 bg-ivory-200 flex items-center justify-center shrink-0">
                        {p.portrait_url ? (
                          <img src={p.portrait_url} alt={p.name} className="w-full h-full object-cover" />
                        ) : (
                          <span className="font-serif text-tulsi">
                            {p.name.trim().charAt(0).toUpperCase()}
                          </span>
                        )}
                      </div>
                      <div className="min-w-0">
                        <div className="text-sm text-ink truncate">{p.name}</div>
                        <div className="text-xs text-ink-50">
                          {[p.birth_year, p.death_year].filter(Boolean).join(" — ") || " "}
                        </div>
                      </div>
                    </button>
                  </li>
                ))}
              </ul>
            </>
          )}

          <div className="mt-6 text-right">
            <button
              onClick={onClose}
              className="text-sm text-ink-50 hover:text-ink transition"
            >
              Cancel
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
